export default (serial) => {
  const textEncoder = new TextEncoder();

  const write = (txt) => {
    const writer = serial.writable.getWriter();
    return writer.write(textEncoder.encode(txt)).then(() => writer.releaseLock());
  };

  const clearCommands = () => {
    return write(';');
  };

  const rebootIntoBootloader = () => {
    return write('POWER:Boot;');
  };

  return { clearCommands, rebootIntoBootloader };
};
